import { render } from "./ChargeDetails.vue?vue&type=template&id=333ea230&scoped=true"
import script from "./ChargeDetails.vue?vue&type=script&lang=js"
export * from "./ChargeDetails.vue?vue&type=script&lang=js"

import "./ChargeDetails.vue?vue&type=style&index=0&id=333ea230&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333ea230"]])

export default __exports__